import { sentryLog } from "@/utils/sentry-utils";

export const CALENDAR_MODES = ["grid", "list"] as const;
export type CalendarMode = (typeof CALENDAR_MODES)[number];

const STORAGE_KEY = "calendar-mode";

/**
 * What the app opens on when nothing has been picked yet (DEV-10546). Grid is
 * the normal calendar; a user who switches to the cashier-oriented list never
 * gets sent back to grid on next launch.
 */
export const FALLBACK_CALENDAR_MODE: CalendarMode = "grid";

export function isCalendarMode(value: unknown): value is CalendarMode {
  return CALENDAR_MODES.includes(value as CalendarMode);
}

export function readStoredCalendarMode(): CalendarMode {
  const stored = (() => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      sentryLog.warn("Failed to read stored calendar mode", { error });
      return null;
    }
  })();

  return isCalendarMode(stored) ? stored : FALLBACK_CALENDAR_MODE;
}

export function storeCalendarMode(mode: CalendarMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch (error) {
    sentryLog.warn("Failed to persist calendar mode", { error, mode });
  }
}
